export type UserTypesStrings = 'Undefined' | 'Clinic' | 'Prescriber' | 'Patient' | 'Chemist'

export enum UserTypes {
  UNDEFINED = 0,
  CLINIC = 1,
  PRESCRIBER = 2,
  PATIENT = 3,
  CHEMIST = 4,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const UserTypesValues: { [key in UserTypes]: string } = {
  [UserTypes.UNDEFINED]: 'Undefined',
  [UserTypes.CLINIC]: 'Clinic',
  [UserTypes.PRESCRIBER]: 'Prescriber',
  [UserTypes.PATIENT]: 'Patient',
  [UserTypes.CHEMIST]: 'Chemist',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const UserTypesMap: { [key: string]: UserTypes } = {
  Undefined: UserTypes.UNDEFINED,
  Clinic: UserTypes.CLINIC,
  Prescriber: UserTypes.PRESCRIBER,
  Patient: UserTypes.PATIENT,
  Chemist: UserTypes.CHEMIST,
} as const

export class UserTypesUtils {
  static toString(value: UserTypes): UserTypesStrings {
    return UserTypesValues[value] as UserTypesStrings
  }

  static fromString(value: UserTypesStrings): UserTypes {
    const enumValue = UserTypesMap[value]
    if (enumValue === undefined) throw new Error(`Invalid UserTypes string: ${value}`)
    return enumValue
  }
}

export type PrescriberTypesStrings = 'Doctor' | 'Nurse' | 'Pharmacist' | 'Therapist' | 'Technician'

export enum PrescriberTypes {
  DOCTOR = 0,
  NURSE = 1,
  PHARMACIST = 2,
  THERAPIST = 3,
  TECHNICIAN = 4,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PrescriberTypesValues: { [key in PrescriberTypes]: string } = {
  [PrescriberTypes.DOCTOR]: 'Doctor',
  [PrescriberTypes.NURSE]: 'Nurse',
  [PrescriberTypes.PHARMACIST]: 'Pharmacist',
  [PrescriberTypes.THERAPIST]: 'Therapist',
  [PrescriberTypes.TECHNICIAN]: 'Technician',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PrescriberTypesMap: { [key: string]: PrescriberTypes } = {
  Doctor: PrescriberTypes.DOCTOR,
  Nurse: PrescriberTypes.NURSE,
  Pharmacist: PrescriberTypes.PHARMACIST,
  Therapist: PrescriberTypes.THERAPIST,
  Technician: PrescriberTypes.TECHNICIAN,
} as const

export class PrescriberTypesUtils {
  static toString(value: PrescriberTypes): PrescriberTypesStrings {
    return PrescriberTypesValues[value] as PrescriberTypesStrings
  }

  static fromString(value: PrescriberTypesStrings): PrescriberTypes {
    const enumValue = PrescriberTypesMap[value]
    if (enumValue === undefined) throw new Error(`Invalid PrescriberTypes string: ${value}`)
    return enumValue
  }
}

export type PrescriberSalutationsStrings = 'Dr.' | 'Mr.' | 'Ms.' | 'Mrs.'

export enum PrescriberSalutations {
  DR_ = 0,
  MR_ = 1,
  MS_ = 2,
  MRS_ = 3,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PrescriberSalutationsValues: { [key in PrescriberSalutations]: string } = {
  [PrescriberSalutations.DR_]: 'Dr.',
  [PrescriberSalutations.MR_]: 'Mr.',
  [PrescriberSalutations.MS_]: 'Ms.',
  [PrescriberSalutations.MRS_]: 'Mrs.',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PrescriberSalutationsMap: { [key: string]: PrescriberSalutations } = {
  'Dr.': PrescriberSalutations.DR_,
  'Mr.': PrescriberSalutations.MR_,
  'Ms.': PrescriberSalutations.MS_,
  'Mrs.': PrescriberSalutations.MRS_,
} as const

export class PrescriberSalutationsUtils {
  static toString(value: PrescriberSalutations): PrescriberSalutationsStrings {
    return PrescriberSalutationsValues[value] as PrescriberSalutationsStrings
  }

  static fromString(value: PrescriberSalutationsStrings): PrescriberSalutations {
    const enumValue = PrescriberSalutationsMap[value]
    if (enumValue === undefined) throw new Error(`Invalid PrescriberSalutations string: ${value}`)
    return enumValue
  }
}

export type PrescriberProofsStrings = 'ID Proof' | 'Address Proof'

export enum PrescriberProofs {
  ID_PROOF = 0,
  ADDRESS_PROOF = 1,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PrescriberProofsValues: { [key in PrescriberProofs]: string } = {
  [PrescriberProofs.ID_PROOF]: 'ID Proof',
  [PrescriberProofs.ADDRESS_PROOF]: 'Address Proof',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PrescriberProofsMap: { [key: string]: PrescriberProofs } = {
  'ID Proof': PrescriberProofs.ID_PROOF,
  'Address Proof': PrescriberProofs.ADDRESS_PROOF,
} as const

export class PrescriberProofsUtils {
  static toString(value: PrescriberProofs): PrescriberProofsStrings {
    return PrescriberProofsValues[value] as PrescriberProofsStrings
  }

  static fromString(value: PrescriberProofsStrings): PrescriberProofs {
    const enumValue = PrescriberProofsMap[value]
    if (enumValue === undefined) throw new Error(`Invalid PrescriberProofs string: ${value}`)
    return enumValue
  }
}

export type GendersStrings = 'Female' | 'Male' | 'Other'

export enum Genders {
  FEMALE = 0,
  MALE = 1,
  OTHER = 2,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const GendersValues: { [key in Genders]: string } = {
  [Genders.FEMALE]: 'Female',
  [Genders.MALE]: 'Male',
  [Genders.OTHER]: 'Other',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const GendersMap: { [key: string]: Genders } = {
  Female: Genders.FEMALE,
  Male: Genders.MALE,
  Other: Genders.OTHER,
} as const

export class GendersUtils {
  static toString(value: Genders): GendersStrings {
    return GendersValues[value] as GendersStrings
  }

  static fromString(value: GendersStrings): Genders {
    const enumValue = GendersMap[value]
    if (enumValue === undefined) throw new Error(`Invalid Genders string: ${value}`)
    return enumValue
  }
}

export type DaysStrings = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday'

export enum Days {
  MONDAY = 0,
  TUESDAY = 1,
  WEDNESDAY = 2,
  THURSDAY = 3,
  FRIDAY = 4,
  SATURDAY = 5,
  SUNDAY = 6,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const DaysValues: { [key in Days]: string } = {
  [Days.MONDAY]: 'Monday',
  [Days.TUESDAY]: 'Tuesday',
  [Days.WEDNESDAY]: 'Wednesday',
  [Days.THURSDAY]: 'Thursday',
  [Days.FRIDAY]: 'Friday',
  [Days.SATURDAY]: 'Saturday',
  [Days.SUNDAY]: 'Sunday',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const DaysMap: { [key: string]: Days } = {
  Monday: Days.MONDAY,
  Tuesday: Days.TUESDAY,
  Wednesday: Days.WEDNESDAY,
  Thursday: Days.THURSDAY,
  Friday: Days.FRIDAY,
  Saturday: Days.SATURDAY,
  Sunday: Days.SUNDAY,
} as const

export class DaysUtils {
  static toString(value: Days): DaysStrings {
    return DaysValues[value] as DaysStrings
  }

  static fromString(value: DaysStrings): Days {
    const enumValue = DaysMap[value]
    if (enumValue === undefined) throw new Error(`Invalid Days string: ${value}`)
    return enumValue
  }
}

export type PatientSalutationsStrings = 'Mr.' | 'Ms.' | 'Mrs.'

export enum PatientSalutations {
  MR_ = 0,
  MS_ = 1,
  MRS_ = 2,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PatientSalutationsValues: { [key in PatientSalutations]: string } = {
  [PatientSalutations.MR_]: 'Mr.',
  [PatientSalutations.MS_]: 'Ms.',
  [PatientSalutations.MRS_]: 'Mrs.',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PatientSalutationsMap: { [key: string]: PatientSalutations } = {
  'Mr.': PatientSalutations.MR_,
  'Ms.': PatientSalutations.MS_,
  'Mrs.': PatientSalutations.MRS_,
} as const

export class PatientSalutationsUtils {
  static toString(value: PatientSalutations): PatientSalutationsStrings {
    return PatientSalutationsValues[value] as PatientSalutationsStrings
  }

  static fromString(value: PatientSalutationsStrings): PatientSalutations {
    const enumValue = PatientSalutationsMap[value]
    if (enumValue === undefined) throw new Error(`Invalid PatientSalutations string: ${value}`)
    return enumValue
  }
}

export type ConsultationStatusesStrings =
  | 'Upcoming'
  | 'Ongoing'
  | 'Completed'
  | 'Canceled By Prescriber'
  | 'Canceled By Patient'
  | 'Awaiting Patient'
  | 'Pending'

export enum ConsultationStatuses {
  UPCOMING = 0,
  ONGOING = 1,
  COMPLETED = 2,
  CANCELED_BY_PRESCRIBER = 3,
  CANCELED_BY_PATIENT = 4,
  AWAITING_PATIENT = 5,
  PENDING = 6,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ConsultationStatusesValues: { [key in ConsultationStatuses]: string } = {
  [ConsultationStatuses.UPCOMING]: 'Upcoming',
  [ConsultationStatuses.ONGOING]: 'Ongoing',
  [ConsultationStatuses.COMPLETED]: 'Completed',
  [ConsultationStatuses.CANCELED_BY_PRESCRIBER]: 'Canceled By Prescriber',
  [ConsultationStatuses.CANCELED_BY_PATIENT]: 'Canceled By Patient',
  [ConsultationStatuses.AWAITING_PATIENT]: 'Awaiting Patient',
  [ConsultationStatuses.PENDING]: 'Pending',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ConsultationStatusesMap: { [key: string]: ConsultationStatuses } = {
  Upcoming: ConsultationStatuses.UPCOMING,
  Ongoing: ConsultationStatuses.ONGOING,
  Completed: ConsultationStatuses.COMPLETED,
  'Canceled By Prescriber': ConsultationStatuses.CANCELED_BY_PRESCRIBER,
  'Canceled By Patient': ConsultationStatuses.CANCELED_BY_PATIENT,
  'Awaiting Patient': ConsultationStatuses.AWAITING_PATIENT,
  Pending: ConsultationStatuses.PENDING,
} as const

export class ConsultationStatusesUtils {
  static toString(value: ConsultationStatuses): ConsultationStatusesStrings {
    return ConsultationStatusesValues[value] as ConsultationStatusesStrings
  }

  static fromString(value: ConsultationStatusesStrings): ConsultationStatuses {
    const enumValue = ConsultationStatusesMap[value]
    if (enumValue === undefined) throw new Error(`Invalid ConsultationStatuses string: ${value}`)
    return enumValue
  }
}

export type ConsultationTypesStrings = 'New' | 'Follow Up'

export enum ConsultationTypes {
  NEW = 0,
  FOLLOW_UP = 1,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ConsultationTypesValues: { [key in ConsultationTypes]: string } = {
  [ConsultationTypes.NEW]: 'New',
  [ConsultationTypes.FOLLOW_UP]: 'Follow Up',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ConsultationTypesMap: { [key: string]: ConsultationTypes } = {
  New: ConsultationTypes.NEW,
  'Follow Up': ConsultationTypes.FOLLOW_UP,
} as const

export class ConsultationTypesUtils {
  static toString(value: ConsultationTypes): ConsultationTypesStrings {
    return ConsultationTypesValues[value] as ConsultationTypesStrings
  }

  static fromString(value: ConsultationTypesStrings): ConsultationTypes {
    const enumValue = ConsultationTypesMap[value]
    if (enumValue === undefined) throw new Error(`Invalid ConsultationTypes string: ${value}`)
    return enumValue
  }
}

export type NotificationTypesStrings =
  | 'Consultation'
  | 'Repeat Prescription Request'
  | 'Reschedule Request'
  | 'Holiday Request'
  | 'Order'

export enum NotificationTypes {
  CONSULTATION = 0,
  REPEAT_PRESCRIPTION_REQUEST = 1,
  RESCHEDULE_REQUEST = 2,
  HOLIDAY_REQUEST = 3,
  ORDER = 4,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const NotificationTypesValues: { [key in NotificationTypes]: string } = {
  [NotificationTypes.CONSULTATION]: 'Consultation',
  [NotificationTypes.REPEAT_PRESCRIPTION_REQUEST]: 'Repeat Prescription Request',
  [NotificationTypes.RESCHEDULE_REQUEST]: 'Reschedule Request',
  [NotificationTypes.HOLIDAY_REQUEST]: 'Holiday Request',
  [NotificationTypes.ORDER]: 'Order',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const NotificationTypesMap: { [key: string]: NotificationTypes } = {
  Consultation: NotificationTypes.CONSULTATION,
  'Repeat Prescription Request': NotificationTypes.REPEAT_PRESCRIPTION_REQUEST,
  'Reschedule Request': NotificationTypes.RESCHEDULE_REQUEST,
  'Holiday Request': NotificationTypes.HOLIDAY_REQUEST,
  Order: NotificationTypes.ORDER,
} as const

export class NotificationTypesUtils {
  static toString(value: NotificationTypes): NotificationTypesStrings {
    return NotificationTypesValues[value] as NotificationTypesStrings
  }

  static fromString(value: NotificationTypesStrings): NotificationTypes {
    const enumValue = NotificationTypesMap[value]
    if (enumValue === undefined) throw new Error(`Invalid NotificationTypes string: ${value}`)
    return enumValue
  }
}

export type PrescriptionStatusesStrings = 'Pending' | 'Approved' | 'Rejected'

export enum PrescriptionStatuses {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PrescriptionStatusesValues: { [key in PrescriptionStatuses]: string } = {
  [PrescriptionStatuses.PENDING]: 'Pending',
  [PrescriptionStatuses.APPROVED]: 'Approved',
  [PrescriptionStatuses.REJECTED]: 'Rejected',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PrescriptionStatusesMap: { [key: string]: PrescriptionStatuses } = {
  Pending: PrescriptionStatuses.PENDING,
  Approved: PrescriptionStatuses.APPROVED,
  Rejected: PrescriptionStatuses.REJECTED,
} as const

export class PrescriptionStatusesUtils {
  static toString(value: PrescriptionStatuses): PrescriptionStatusesStrings {
    return PrescriptionStatusesValues[value] as PrescriptionStatusesStrings
  }

  static fromString(value: PrescriptionStatusesStrings): PrescriptionStatuses {
    const enumValue = PrescriptionStatusesMap[value]
    if (enumValue === undefined) throw new Error(`Invalid PrescriptionStatuses string: ${value}`)
    return enumValue
  }
}

export type OrderStatusesStrings =
  | 'Unfulfilled'
  | 'Ready For Dispense'
  | 'Partially Fulfilled'
  | 'Fulfilled'
  | 'Dispatched'
  | 'Delivered'
  | 'Cancelled'

export enum OrderStatuses {
  UNFULFILLED = 0,
  READY_FOR_DISPENSE = 1,
  PARTIALLY_FULFILLED = 2,
  FULFILLED = 3,
  DISPATCHED = 4,
  DELIVERED = 5,
  CANCELLED = 6,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const OrderStatusesValues: { [key in OrderStatuses]: string } = {
  [OrderStatuses.UNFULFILLED]: 'Unfulfilled',
  [OrderStatuses.READY_FOR_DISPENSE]: 'Ready For Dispense',
  [OrderStatuses.PARTIALLY_FULFILLED]: 'Partially Fulfilled',
  [OrderStatuses.FULFILLED]: 'Fulfilled',
  [OrderStatuses.DISPATCHED]: 'Dispatched',
  [OrderStatuses.DELIVERED]: 'Delivered',
  [OrderStatuses.CANCELLED]: 'Cancelled',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const OrderStatusesMap: { [key: string]: OrderStatuses } = {
  Unfulfilled: OrderStatuses.UNFULFILLED,
  'Ready For Dispense': OrderStatuses.READY_FOR_DISPENSE,
  'Partially Fulfilled': OrderStatuses.PARTIALLY_FULFILLED,
  Fulfilled: OrderStatuses.FULFILLED,
  Dispatched: OrderStatuses.DISPATCHED,
  Delivered: OrderStatuses.DELIVERED,
  Cancelled: OrderStatuses.CANCELLED,
} as const

export class OrderStatusesUtils {
  static toString(value: OrderStatuses): OrderStatusesStrings {
    return OrderStatusesValues[value] as OrderStatusesStrings
  }

  static fromString(value: OrderStatusesStrings): OrderStatuses {
    const enumValue = OrderStatusesMap[value]
    if (enumValue === undefined) throw new Error(`Invalid OrderStatuses string: ${value}`)
    return enumValue
  }
}

export type ShipmentStatusesStrings = 'Pending' | 'Approved' | 'Rejected'

export enum ShipmentStatuses {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ShipmentStatusesValues: { [key in ShipmentStatuses]: string } = {
  [ShipmentStatuses.PENDING]: 'Pending',
  [ShipmentStatuses.APPROVED]: 'Approved',
  [ShipmentStatuses.REJECTED]: 'Rejected',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ShipmentStatusesMap: { [key: string]: ShipmentStatuses } = {
  Pending: ShipmentStatuses.PENDING,
  Approved: ShipmentStatuses.APPROVED,
  Rejected: ShipmentStatuses.REJECTED,
} as const

export class ShipmentStatusesUtils {
  static toString(value: ShipmentStatuses): ShipmentStatusesStrings {
    return ShipmentStatusesValues[value] as ShipmentStatusesStrings
  }

  static fromString(value: ShipmentStatusesStrings): ShipmentStatuses {
    const enumValue = ShipmentStatusesMap[value]
    if (enumValue === undefined) throw new Error(`Invalid ShipmentStatuses string: ${value}`)
    return enumValue
  }
}

export type PaymentStatusesStrings =
  | 'Pending'
  | 'Initiated'
  | 'Completed'
  | 'Failed'
  | 'Refund Initiated'
  | 'Refund Processed'

export enum PaymentStatuses {
  PENDING = 0,
  INITIATED = 1,
  COMPLETED = 2,
  FAILED = 3,
  REFUND_INITIATED = 4,
  REFUND_PROCESSED = 5,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PaymentStatusesValues: { [key in PaymentStatuses]: string } = {
  [PaymentStatuses.PENDING]: 'Pending',
  [PaymentStatuses.INITIATED]: 'Initiated',
  [PaymentStatuses.COMPLETED]: 'Completed',
  [PaymentStatuses.FAILED]: 'Failed',
  [PaymentStatuses.REFUND_INITIATED]: 'Refund Initiated',
  [PaymentStatuses.REFUND_PROCESSED]: 'Refund Processed',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PaymentStatusesMap: { [key: string]: PaymentStatuses } = {
  Pending: PaymentStatuses.PENDING,
  Initiated: PaymentStatuses.INITIATED,
  Completed: PaymentStatuses.COMPLETED,
  Failed: PaymentStatuses.FAILED,
  'Refund Initiated': PaymentStatuses.REFUND_INITIATED,
  'Refund Processed': PaymentStatuses.REFUND_PROCESSED,
} as const

export class PaymentStatusesUtils {
  static toString(value: PaymentStatuses): PaymentStatusesStrings {
    return PaymentStatusesValues[value] as PaymentStatusesStrings
  }

  static fromString(value: PaymentStatusesStrings): PaymentStatuses {
    const enumValue = PaymentStatusesMap[value]
    if (enumValue === undefined) throw new Error(`Invalid PaymentStatuses string: ${value}`)
    return enumValue
  }
}
